import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { ZoomableImage } from '../_core/_ui/zoomable-image.component';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { SportTerminology } from '../../lib/types';
import { FormatTemplateCountChips } from './format-template-count-chips.component';
import { messages } from './format-template.messages';

interface IFormatTemplateBandSummaryProps {
  bands: IFormatTemplateBand[];
}

// A composed template stores no stages of its own — each band builds them from the roster at
// apply time — so a preview without an age group lists the bands instead of a stage list.
export const FormatTemplateBandSummary: React.FC<IFormatTemplateBandSummaryProps> = ({ bands }) => {
  const termLookup = useCompanySportTerminology();

  return (
  <>
    <Typography variant="subtitle2">
      <IntlMsg {...messages.bandsTitle} values={{ skaterWord: termLookup[SportTerminology.SKATER] }} />
    </Typography>
    <Typography variant="caption" color="textSecondary"><IntlMsg {...messages.bandsHelp} /></Typography>
    {bands.map(band => (
      <Box key={band.key} mt={2}>
        <Typography variant="body2">{band.label || band.key}</Typography>
        <Box display="flex" flexWrap="wrap" mt={0.5} style={{ gap: 4 }}>
          <FormatTemplateCountChips
            sessionTotal={band.totalAssessmentSessions}
            groupCount={band.groupCount}
            teamCount={band.teamOutcomes?.length}
          />
        </Box>
        <Box mt={1}>
          <ZoomableImage src={band.imageUrl} alt={band.label || band.key} minHeight={160} maxHeight={280} mb={0} />
        </Box>
      </Box>
    ))}
  </>
  );
};
